import { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PageLayout from '@/layouts/page';
import { goReplace } from '@/utils';


const UnExitTask: FC<{}> = () => {
  const history = useHistory();
  const [times, setTimes] = useState(0);

  useEffect(() => {
    if (times < 3) {
      setTimeout(() => {
        setTimes(times + 1);
      }, 1000);
    } else {
      handleBack();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [times]);
  
  const handleBack = () => {
    goReplace(history, '/add-friend-tasks');
  }

  return (
    <PageLayout onBack={handleBack}>
      <div style={{ height: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div>
          <div style={{ textAlign: 'center' }}>
            <img height={80} src='https://brand-guide.shuyun.com/IAM/43808646f43e.png' alt='' />
          </div>
          <div style={{ textAlign: 'center', color: '#C0C4CC', fontSize: 14, lineHeight: '46px' }}>
            该任务已被删除，{3 - times} 秒后跳至首页
          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default UnExitTask;